export default "__VITE_ASSET__DmMCYvrg__"